<template>
    <main-content-wrapper>
       <step-marker :steps="['Podatki o kartici','Prijavni podatki']" :current="1" />
        <h1 class="text-md-center  font-weight-regular">
            REGISTRACIJA
            <span>Registrirajte se s Tuš Cash & Carry klub kartico in koristite morebitne pogodbene popuste.</span>
        </h1>
        <v-layout justify-center row wrap fill-height >
            <v-flex xs12 md6 pl-5 pr-5 pt-4 pb-4 class="border">
                <split-content text="Podatki za prijavo"/>
                <div class="mt-4 mb-4 font-weight-bold">Vpišite vaš email naslov in geslo, ki ga boste uporabljali za prijavo. Prijava bo mogoča zgolj in samo s temi podatki.</div>
                <empty-space />
                <v-flex xs12 sm12>
                    <v-form v-model="valid" @submit.prevent="" ref="form">
                        <v-alert
                                :value="invalid_no_cond"
                                type="error"
                        >
                            Za nadaljevanje se je potrebno strinjati s pogoji poslovanja.
                        </v-alert>
                        <v-alert
                                :value="error_creating!=null"
                                type="error"
                        >
                            {{ error_creating }}
                        </v-alert>
                        <email-field v-if="!confirm_code" v-model="email" label="Vpišite vaš e-naslov" :error-messages="email_error_messages" :rules="[checkEmail]" ref="email_input" required />
                        <template v-if="confirm_code">
                            <div class="text-xs-center" >
                                <div class="existing-email">
                                    {{ confirm_code_other.email }}
                                </div>
                                <v-btn small depressed @click="otherEmailAddress">Uporabi drug e-naslov</v-btn>
                            </div>
                            <empty-space />
                        </template>
                        <password-field v-model="password" :rules="newPasswordRules" label="Izberite geslo" required/>
                        <password-field v-model="password_again" :rules="[checkNewPasswordAgain]" label="Ponovno vpišite geslo" required/>
                        <v-checkbox
                                v-model="confirm_cond"
                                required
                        >
                            <div slot="label">
                                Strinjam se s <a target="_blank" href="https://www.tuscc.si/splosni-pogoji-poslovanja" v-on:click.stop="" class="terms">splošnimi pogoji poslovanja</a>.
                            </div>
                        </v-checkbox>
                        <empty-space />
                    </v-form>
                </v-flex>
                <v-btn depressed large block color="primary_action" @click="createAccount" :loading="loading">POTRDI</v-btn>
            </v-flex>
        </v-layout>
    </main-content-wrapper>
</template>

<script>
    import Router from '../router';
    import MainContentWrapper from "../components/MainContentWrapper";
    import SplitContent from "../components/SplitContent";
    import EmptySpace from "../components/EmptySpace";
    import PasswordField from "../components/PasswordField";
    import EmailField from "../components/EmailField";
    import {userService} from "../services";
    import validations from "../components/validations";
    import utils from "../store/utils";
    import StepMarker from '@/components/StepMarker.vue'

    export default {
        name: "CreateAccountWithCard",
        data: vm => ({
            loading: false,
            invalid_no_cond: false,
            confirm_cond: false,
            email: null,
            password: null,
            password_again: null,
            email_error_messages: null,
            error_creating: null
        }),
        components: { StepMarker, SplitContent, MainContentWrapper, EmptySpace, PasswordField, EmailField},
        computed: {
            confirm_code: utils.vuexBuildSetGet(this, 'auth', 'confirm_code'),
            confirm_code_other: utils.vuexBuildSetGet(this, 'auth', 'confirm_code_other'),
        },
        methods: {
            checkEmail(v){
                this.email_error_messages = [];
                let noError = validations.checkEmailAll(v);
                if (noError === true){
                    userService.checkEmail(v).then(
                        data => {
                            this.email_error_messages = null;
                        },
                        error => {
                            if (error.message) {
                                this.email_error_messages = [error.message];
                            } else {
                                this.email_error_messages = ['Napaka pri preverjanju naslova.'];
                            }
                        }
                    );
                    return true;
                }
                return noError;
            },
            checkNewPasswordAgain(v) {
                return validations.newPasswordCheckAgain(v, this.password);
            },
            createAccount(){
                let isValidAccount = this.$refs.form.validate();
                this.invalid_no_cond = this.confirm_cond == false;
                if (isValidAccount && this.confirm_cond) {
                    this.loading = true;
                    this.error_creating = null;
                    if (this.confirm_code){
                        this.email = this.confirm_code_other.email;
                    }
                    userService.createAccountForSelectedCard(this.email, this.password, this.confirm_code).then(
                        (data)=>{
                            if (!data.email_sent){
                                this.$router.push('/ustvari/privolitve');
                            } else {
                                this.$store.dispatch('application/emailSentMessage', {
                                    'title': 'Registracijo ste že skoraj zaključili.',
                                    'text': 'Za dokončanje postopka potrdite povezavo, ki smo jo poslali na vaš e-naslov.'
                                });
                            }
                        },
                        (error) =>{
                            this.error_creating = error.message;
                        }
                    ).finally(()=>{
                        this.loading = false;
                    });
                }
                //Router.push('/ustvari/privolitve');
            },
            otherEmailAddress(){
                this.$store.commit('auth/setConfirmCode', null);
                this.$store.commit('auth/setConfirmCodeOtherData', null);
            }
        }
    }
</script>

<style scoped>

    .existing-email {
        font-size: 1.8em;
        font-weight: bold;
    }
</style>
